import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-gift.tsx
/**
* icon.24.gift
*
* Keywords: present, package, ribbon, box, celebration, wrapped, bow
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNSA3LjUxVjloLTEuNDlDOC42ODMgOSA4LjAyIDcuMzk1IDguOTU3IDYuNDU3UzExLjUgNi4xODMgMTEuNSA3LjUxTTguMjUgNS43NWMtLjk1Ny45NTYtLjkxNyAyLjMyNy0uMjM3IDMuMjVINy41QTEuNSAxLjUgMCAwIDAgNiAxMC41djFhMS41IDEuNSAwIDAgMCAxIDEuNDE1djMuNTg2QTEuNSAxLjUgMCAwIDAgOC41IDE4aDdhMS41IDEuNSAwIDAgMCAxLjUtMS41di0zLjU4NmExLjUgMS41IDAgMCAwIDEtMS40MTR2LTFBMS41IDEuNSAwIDAgMCAxNi41IDloLTEuMjY4YTIgMiAwIDAgMC0yLjk3LTIuNTcxYy0uNjkxLTEuNDUtMi43MjYtMS45NjYtNC4wMTItLjY4TTEyLjUgOWgxYTEgMSAwIDEgMC0xLTF6TTggMTN2My41YS41LjUgMCAwIDAgLjUuNWgzdi00em00LjUgMHY0aDNhLjUuNSAwIDAgMCAuNS0uNVYxM3ptMC0xdi0yaDRhLjUuNSAwIDAgMSAuNS41djFhLjUuNSAwIDAgMS0uNS41em0tMS0ydjJoLTRhLjUuNSAwIDAgMS0uNS0uNXYtMWEuNS41IDAgMCAxIC41LS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=832-5926
*/
const Icon24Gift = memo(function Icon24Gift(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M11.5 7.51V9h-1.49C8.683 9 8.02 7.395 8.957 6.457S11.5 6.183 11.5 7.51M8.25 5.75c-.957.956-.917 2.327-.237 3.25H7.5A1.5 1.5 0 0 0 6 10.5v1a1.5 1.5 0 0 0 1 1.415v3.586A1.5 1.5 0 0 0 8.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-3.586a1.5 1.5 0 0 0 1-1.414v-1A1.5 1.5 0 0 0 16.5 9h-1.268a2 2 0 0 0-2.97-2.571c-.691-1.45-2.726-1.966-4.012-.68M12.5 9h1a1 1 0 1 0-1-1zM8 13v3.5a.5.5 0 0 0 .5.5h3v-4zm4.5 0v4h3a.5.5 0 0 0 .5-.5V13zm0-1v-2h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-1-2v2h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M11 8v-.5A1.5 1.5 0 1 0 9.5 9H11zm.76-1.57A2.5 2.5 0 1 0 7.5 9 1.5 1.5 0 0 0 6 10.5v1a1.5 1.5 0 0 0 1 1.415v3.586A1.5 1.5 0 0 0 8.5 18h6a1.5 1.5 0 0 0 1.5-1.5v-3.586a1.5 1.5 0 0 0 1-1.414v-1A1.5 1.5 0 0 0 15.5 9h-.768a2 2 0 0 0-2.972-2.57M12 8v1h1a1 1 0 1 0-1-1m-4 5v3.5a.5.5 0 0 0 .5.5H11v-4zm4 0v4h2.5a.5.5 0 0 0 .5-.5V13zm0-1v-2h3.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-1-2v2H7.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Gift };

//# sourceMappingURL=icon-24-gift.js.map